import * as ACTION_TYPES from './actiontypes';

export const changeInputValue = (type, name, value) => ({
  type: ACTION_TYPES.CHANGE_INPUT_VALUE,
  payload: {
    type,
    name,
    value
  }
});

export const initRequest = () => ({
  type: ACTION_TYPES.INIT_REQUEST
});

export const initSuccess = result => ({
  type: ACTION_TYPES.INIT_SUCCESS,
  payload: {
    ...result
  }
});

export const initFailure = error => ({
  type: ACTION_TYPES.INIT_FAILURE,
  error
});

export const searchRequest = () => ({
  type: ACTION_TYPES.SEARCH_REQUEST
});

export const searchSuccess = results => ({
  type: ACTION_TYPES.SEARCH_SUCCESS,
  payload: {
    results
  }
});

export const searchFailure = error => ({
  type: ACTION_TYPES.SEARCH_FAILURE,
  error
});

export const selectCriteriaItem = (itemType, itemId) => ({
  type: ACTION_TYPES.SELECT_CRITERIA_ITEM,
  payload: {
    itemType,
    itemId
  }
});

export const removeCriteriaItem = (itemType, itemId) => ({
  type: ACTION_TYPES.REMOVE_CRITERIA_ITEM,
  payload: {
    itemType,
    itemId
  }
});

export const navigateToDetails = encounterId => ({
  type: ACTION_TYPES.NAVIGATE_TO_DETAILS,
  payload: {
    encounterId
  }
});

export const getCodersRequest = () => ({
  type: ACTION_TYPES.GET_CODERS_REQUEST
});

export const getCodersSuccess = () => ({
  type: ACTION_TYPES.GET_CODERS_SUCCESS
});

export const getCodersFailure = error => ({
  type: ACTION_TYPES.GET_CODERS_FAILURE,
  error
});
